// extracted by mini-css-extract-plugin
export default {"inputWrapper":"RadioButtons_inputWrapper__prpvD","inputLabel":"RadioButtons_inputLabel__55nTA","input":"RadioButtons_input__14192"};